/* hom51-p51.js · Gruppe T2 · Playboy51-Seite: Karte, Vlog-Popup, Fan-Band, Popup, Countdown (T3 19.10.: Fan-Popup wartet auf Pushowl) */
(function(){
'use strict';
var $=function(s,r){return (r||document).querySelector(s)},$$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
var ss={get:function(k){try{return sessionStorage.getItem(k)}catch(e){return null}},set:function(k,v){try{sessionStorage.setItem(k,v)}catch(e){}}};
/* ---- Vlog-Popup (YouTube erst bei Klick laden) ---- */
var modal;
function openYT(id,url){
  if(!modal){
    modal=document.createElement('div');modal.className='p51-modal';modal.setAttribute('role','dialog');modal.setAttribute('aria-modal','true');modal.setAttribute('aria-label','Vlog');
    modal.innerHTML='<div><div class="p51-modal__box"><button class="p51-x" type="button" aria-label="Schließen">×</button></div><p class="p51-note" style="text-align:center;margin-top:14px"><a class="p51-yl" target="_blank" rel="noopener" style="color:#e8c360">Falls das Video hier nicht startet: auf YouTube öffnen</a></p></div>';
    document.body.appendChild(modal);
    modal.addEventListener('click',function(e){if(e.target===modal||e.target.classList.contains('p51-x'))closeYT()});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')closeYT()});
  }
  var box=$('.p51-modal__box',modal);var old=$('iframe',box);if(old)old.remove();
  var f=document.createElement('iframe');f.src='https://www.youtube-nocookie.com/embed/'+encodeURIComponent(id)+'?autoplay=1&rel=0';f.allow='autoplay; encrypted-media; picture-in-picture; fullscreen';f.allowFullscreen=true;f.title='Vlog';
  box.insertBefore(f,box.firstChild);$('.p51-yl',modal).href=url||('https://www.youtube.com/watch?v='+id);
  modal.classList.add('is-on');$('.p51-x',modal).focus();
}
function closeYT(){if(!modal)return;modal.classList.remove('is-on');var f=$('iframe',modal);if(f)f.remove()}
window.P51={openYT:openYT};
document.addEventListener('click',function(e){
  var t=e.target.closest('[data-yt]');if(!t)return;
  var id=t.getAttribute('data-yt');if(!id)return;
  e.preventDefault();openYT(id,t.getAttribute('href')||t.getAttribute('data-url'));
});
/* ---- Reise: Stationen ---- */
$$('[data-p51-reise]').forEach(function(root){
  var pins=$$('.p51-pin',root),cards=$$('.p51-st',root);
  function show(i){pins.forEach(function(p,k){p.setAttribute('aria-pressed',k===i?'true':'false')});cards.forEach(function(c,k){c.classList.toggle('is-on',k===i)})}
  pins.forEach(function(p,i){p.addEventListener('click',function(){show(i);if(window.innerWidth<990){var c=cards[i];if(c&&c.scrollIntoView)c.scrollIntoView({behavior:'smooth',block:'nearest'})}})});
  var s=parseInt(root.getAttribute('data-start')||'0',10);show(isNaN(s)?0:s);
});
/* ---- Countdown ---- */
function pad(n){return n<10?'0'+n:''+n}
var cds=$$('[data-p51-countdown]');
function tick(){
  var now=Date.now();
  cds.forEach(function(el){
    var end=new Date(el.getAttribute('data-end')).getTime();if(isNaN(end))return;
    var d=end-now;
    if(d<=0){el.setAttribute('data-over','1');var o=el.getAttribute('data-over-text');if(o)el.textContent=o;return}
    var s=Math.floor(d/1000),dd=Math.floor(s/86400),hh=Math.floor(s%86400/3600),mm=Math.floor(s%3600/60),ss_=s%60;
    if(el.hasAttribute('data-compact')){el.textContent=dd+'T '+pad(hh)+':'+pad(mm)+':'+pad(ss_)}
    else{var v=[dd,hh,mm,ss_];$$('b',el).forEach(function(b,i){if(v[i]!==undefined)b.textContent=pad(v[i])})}
  });
}
if(cds.length){tick();setInterval(tick,1000)}
/* ---- Code kopieren + Rabatt anwenden ---- */
function copyText(t){
  if(navigator.clipboard&&navigator.clipboard.writeText)return navigator.clipboard.writeText(t);
  return new Promise(function(res){var a=document.createElement('textarea');a.value=t;a.style.position='fixed';a.style.opacity='0';document.body.appendChild(a);a.select();try{document.execCommand('copy')}catch(e){}a.remove();res()});
}
document.addEventListener('click',function(e){
  var b=e.target.closest('[data-p51-copy]');if(!b)return;
  var code=b.getAttribute('data-p51-copy');var lab=b.getAttribute('data-done')||'Kopiert';
  copyText(code).then(function(){
    var keep=b.textContent;b.setAttribute('data-keep',keep);b.textContent=lab;setTimeout(function(){b.textContent=b.getAttribute('data-keep')||keep},2200);
  });
  try{fetch('/discount/'+encodeURIComponent(code),{credentials:'same-origin'}).catch(function(){})}catch(err){}
  var go=b.getAttribute('data-go');if(go){var t=document.querySelector(go);if(t)t.scrollIntoView({behavior:'smooth'})}
  var pop=b.closest('.p51-pop');if(pop)pop.classList.remove('is-on');
});
/* ---- Band + Popup ---- */
$$('[data-p51-band]').forEach(function(band){
  var over=function(){var el=$('[data-p51-countdown]',band)||band;return new Date(band.getAttribute('data-end')).getTime()<Date.now()};
  if(over()){band.hidden=true;return}
  if(ss.get('p51band')==='0'){band.hidden=true}
  var x=$('.p51-fb__x',band);if(x)x.addEventListener('click',function(){band.hidden=true;ss.set('p51band','0')});
});
/* Pushowl-Erkennung: Fan-Popup erscheint nie ueber dem Pushowl-/Browser-Abfrage-Popup */
function pushowlOpen(){
  var els=$$('[id*="pushowl" i],[class*="pushowl" i],iframe[src*="pushowl" i]');
  for(var i=0;i<els.length;i++){var r=els[i].getBoundingClientRect();var cs=window.getComputedStyle(els[i]);
    if(r.width>80&&r.height>40&&cs.display!=='none'&&cs.visibility!=='hidden'&&cs.opacity!=='0')return true}
  return false;
}
$$('[data-p51-pop]').forEach(function(pop){
  if(new Date(pop.getAttribute('data-end')).getTime()<Date.now())return;
  if(ss.get('p51pop')==='1')return;
  var delay=Math.max(parseInt(pop.getAttribute('data-delay')||'20',10),20)*1000,shown=false,t0=Date.now();
  function open(){
    if(shown||ss.get('p51pop')==='1')return;
    if(pushowlOpen()&&Date.now()-t0<90000){setTimeout(open,2000);return}
    shown=true;ss.set('p51pop','1');pop.classList.add('is-on');var c=$('.p51-x',pop);if(c)c.focus()}
  function close(){pop.classList.remove('is-on')}
  setTimeout(open,delay);
  window.addEventListener('scroll',function s(){if(window.scrollY>window.innerHeight*1.2){window.removeEventListener('scroll',s);setTimeout(open,Math.max(0,delay-(Date.now()-t0)))}},{passive:true});
  pop.addEventListener('click',function(e){if(e.target===pop||e.target.closest('[data-close]'))close()});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close()});
});
})();
